
const digest = '8f5defa262ca780dd54085ac545e6097cdca412ad351c5ba4511381976668f1c';
const classes = {"wrapper":"_wrapper_65dw9_1","warning":"_warning_65dw9_6"};
const css = `._wrapper_65dw9_1 {
  display: flex;
  flex-direction: column;
  font-family: Rubik, "sans-serif";
}
._wrapper_65dw9_1 ._warning_65dw9_6 {
  font-weight: 500;
  color: #f1a128;
  border: 1px solid #f1a128;
  padding: 20px;
  font-size: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  